module.exports = __webpack_public_path__ + "static/media/cases_3d_01f.dc38a2df.jpg";